var path = '/modules/contacts/views/pages/duplicates.tpl.html';
var html = "<div class=\"content-box\" ng-if=\"vm.loading\">\n    <al-loader size=\"medium\"></al-loader>\n</div>\n\n<duplicates-listview store=\"vm.store\" ng-if=\"!vm.loading\"></duplicates-listview>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/contacts/views/pages/duplicates.tpl.html
// module id = 2080
// module chunks = 1